export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7404.db172cd5.jpg";